module.exports = __webpack_public_path__ + "assets/img/thumb-fallback3.25725bc9.jpg";